import { systemOwnerId } from "@lorevok/domain";
import { useT } from "../lib/i18n/store.js";
import { fallBackToSource, sizedImageUrl } from "../lib/imageUrl.js";
import { authorHref, followInApp } from "../lib/links.js";

/**
 * "by ‹name›" author byline that links to the author's public profile — a real
 * link to /u/<username> that opens the page in-app on a plain click
 * (lib/links.ts). Renders nothing when there is no display name to show or the
 * novel belongs to the built-in system/demo owner (which has no meaningful
 * author page).
 */
export function AuthorByline({
  ownerId,
  username,
  displayName,
  avatarUrl,
  onOpenAuthor,
  className
}: {
  ownerId: string;
  /** The author's permanent username: the link goes to /u/<username>. */
  username?: string;
  displayName?: string;
  avatarUrl?: string | null;
  onOpenAuthor: (ownerId: string, username?: string) => void;
  className?: string;
}) {
  const t = useT();
  if (!displayName || ownerId === systemOwnerId) return null;
  return (
    <a
      className={className ? `author-byline ${className}` : "author-byline"}
      href={authorHref(ownerId, username)}
      onClick={(event) => {
        event.stopPropagation();
        followInApp(event, () => onOpenAuthor(ownerId, username));
      }}
    >
      {avatarUrl && <img className="author-byline-avatar" src={sizedImageUrl(avatarUrl, 20, { aspect: 1 })} onError={fallBackToSource(avatarUrl)} alt="" />}
      <span>{t("common.byAuthor", { name: displayName })}</span>
    </a>
  );
}
